import styled from "styled-components";
import Img from "../../assets/images/parallex.jpg";

export const StyledSection = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 4rem;
  h1 {
    color: ${({ theme }) => theme.colors.textColor};
    font-style: normal;
    font-size: 38px;
    line-height: 43px;
    width: 40%;
  }

  .row {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  p {
    font-style: normal;
    font-size: 20px;
    line-height: 22px;
    color: #000000;
  }

  .styled-button {
    width: 170px;
    height: 70px;
    border-radius: 20px;
    font-size: 20px;
    font-weight: bold;
    border: none;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.secondary};
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  span {
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 28px;
    color: ${({ theme }) => theme.colors.primary};
  }
  @media (max-width: 500px) {
    h1 {
      color: ${({ theme }) => theme.colors.textColor};
      font-style: normal;
      font-size: 32px;
      line-height: 43px;
      width: 100%;
    }
  }
`;
export const StyledParallex = styled.div`
  background-image: url(${Img});
  margin-top: 3rem;
  min-height: 500px;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
`;
